import { useState } from "react";
import {
  TelephoneFill,
  CalendarCheck,
  Telephone,
  Clipboard
} from "react-bootstrap-icons";

import logo from "../../assets/iRise-psychology-Logo1.png";

export default function BenHero() {
  const [showPhones, setShowPhones] = useState(false);
  const [activeDoctor, setActiveDoctor] = useState(null);

  const doctors = [
    { name: "Dr Benjamin Piper", phone: "07929040880" },
    { name: "Dr René De Barr", phone: "07539447298" }
  ];

  const copyNumber = (number) => {
    navigator.clipboard.writeText(number);
  };

  return (
<section className="profile-hero py-5 d-flex align-items-center justify-content-center">
  <div className="hero-slogan">
    <p className="lead mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
  </div>
</section>
  );
}